import { useMutation, UseMutationResult } from "@tanstack/react-query";

import {
  EmptyObject,
  WiseOwlApiResponse,
  WiseOwlIngress,
  WiseOwlProps,
} from "@twiliointernal/e2-commons-shared-definitions";

import { types } from "./definitions";
import { WiseOwlApi } from "@twiliointernal/e2-commons-shared-api";

const useSubmitFeedback = ({
  applicationId,
  ingress,
  stargateUngatedUserId,
  token,
  user,
}: WiseOwlProps): UseMutationResult<
  WiseOwlApiResponse<EmptyObject>,
  any,
  types.UseWiseOwlSubmitFeedbackArgs
> => {
  return useMutation({
    mutationFn: async (args: types.UseWiseOwlSubmitFeedbackArgs) => {
      const wiseOwlApi = new WiseOwlApi(ingress);

      const { chatId, messageId, positive, feedback } = args;

      const bodyDefaults = {
        feedback,
        positive,
      };

      switch (ingress) {
        case WiseOwlIngress.oscUngated: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            body: {
              ...bodyDefaults,
              stargateUngatedUserId,
            },
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
        case WiseOwlIngress.osc: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            body: bodyDefaults,
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
        case WiseOwlIngress.console: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            body: { ...bodyDefaults, applicationId },
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
        case WiseOwlIngress.zendesk: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            body: bodyDefaults,
            headers: {
              "wozd-auth": token,
            },
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
        case WiseOwlIngress.salesforce: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            body: bodyDefaults,
            headers: {
              "salesforce-auth": token,
            },
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
        case WiseOwlIngress.wiseOwlApp: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            body: bodyDefaults,
            headers: {
              "x-twilio-e2-ingress": WiseOwlIngress.wiseOwlApp,
              "x-twilio-e2-auth-token": token,
              "x-twilio-e2-session-id": user.uid || "",
            },
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
        case WiseOwlIngress.sendGrid: {
          return wiseOwlApi.createFeedback({
            ingress,
            chatId,
            messageId,
            headers: {
              "i-sendgrid-auth-mako-token": token,
              "i-sendgrid-auth-user-id": user.sendGridUserId || "",
            },
            body: bodyDefaults,
          }) as Promise<WiseOwlApiResponse<EmptyObject>>;
        }
      }
    },
  });
};

export default useSubmitFeedback;
